import React from "react";
import { BrowserRouter, Route, Navigate, Routes } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ShipmentRegister from './pages/shipment-register';
import ReportsAndAnalytics from './pages/reports-and-analytics';
import DocumentManagementCenter from './pages/document-management-center';
import MonthlyReviewNotes from './pages/monthly-review-notes';
import CostRegister from './pages/cost-register';
import OperationsDashboard from './pages/operations-dashboard';
import UserAndRoleManagement from './pages/user-and-role-management';
import FeeRegister from './pages/fee-register';
import IssueAndRiskLog from './pages/issue-and-risk-log';
import MasterDataManagement from './pages/master-data-management';
import GeneralLedger from "pages/general-ledger";
import AccountsPayable from "pages/accounts-payable";
import AccountsReceivable from "pages/accounts-receivable";
import Invoices from 'pages/invoices';
import BankReconciliation from "pages/bank-reconciliation";
import ExchangeRates from "pages/exchange-rates";
import FinancialStatements from "pages/financial-statements";
import ProtectedRoute from './components/ProtectedRoute';
import WorkflowManagement from './pages/workflow-management';

// Auth pages
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';

function AppRoutes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
          {/* Public auth routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Redirect root to login */}
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Protected routes - require authentication */}
          <Route
            path="/operations-dashboard"
            element={
              <ProtectedRoute>
                <OperationsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shipment-register"
            element={
              <ProtectedRoute>
                <ShipmentRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cost-register"
            element={
              <ProtectedRoute>
                <CostRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/fee-register"
            element={
              <ProtectedRoute>
                <FeeRegister />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts-payable"
            element={
              <ProtectedRoute allowedRoles={['admin', 'business_manager', 'finance_analyst']}>
                <AccountsPayable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/accounts-receivable"
            element={
              <ProtectedRoute allowedRoles={['admin', 'business_manager', 'finance_analyst']}>
                <AccountsReceivable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute allowedRoles={['admin', 'business_manager', 'finance_analyst']}>
                <Invoices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/bank-reconciliation"
            element={
              <ProtectedRoute allowedRoles={['admin', 'finance_analyst']}>
                <BankReconciliation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/exchange-rates"
            element={
              <ProtectedRoute allowedRoles={['admin', 'finance_analyst']}>
                <ExchangeRates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/general-ledger"
            element={
              <ProtectedRoute allowedRoles={['admin', 'finance_analyst']}>
                <GeneralLedger />
              </ProtectedRoute>
            }
          />
          <Route
            path="/financial-statements"
            element={
              <ProtectedRoute allowedRoles={['admin', 'finance_analyst']}>
                <FinancialStatements />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monthly-review-notes"
            element={
              <ProtectedRoute>
                <MonthlyReviewNotes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/issue-and-risk-log"
            element={
              <ProtectedRoute>
                <IssueAndRiskLog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports-and-analytics"
            element={
              <ProtectedRoute>
                <ReportsAndAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/document-management-center"
            element={
              <ProtectedRoute>
                <DocumentManagementCenter />
              </ProtectedRoute>
            }
          />
          <Route
            path="/master-data-management"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <MasterDataManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-and-role-management"
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <UserAndRoleManagement />
              </ProtectedRoute>
            }
          />
          <Route path="/workflow-management" element={<WorkflowManagement />} />

          {/* 404 page */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default AppRoutes;